// extracted by mini-css-extract-plugin
export default {"root":"IconAddToShortList_root__slKCx"};